import { AdminConsolePageDetails, AdminConsoleSectionDetails } from "../types/adminConsoleTypes";

export const acSectionCreationInitialValues: AdminConsoleSectionDetails = {
  id: "",
  title: "",
  titleEn: "",
  position: 1,
  accessRoles: [],
  pages: [],
};

export const acPageCreationInitialValues: AdminConsolePageDetails = {
  id: "",
  parentId: "",
  title: "",
  titleEn: "",
  position: 1,
  accessRoles: [],
  href: "",
  children: [],
};
